import React from 'react';
import { Grid } from '@material-ui/core';
import Select from 'src/common/components/form/select/Select.jsx';
import { DropdownLabel } from './questionDropDownStyled';
import { isMobileView } from 'src/utils/util';
import { useTranslation } from 'react-i18next';
const QuestionDropDown = ({
    options,
    onChange,
    uiv,
    liv,
    optionLabel,
    dropLabelFirst,
    dropLabelSecond,
}) => {
    const { t } = useTranslation();
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                padding: '34px 0px 10px',
            }}
        >
            <Grid lg={2} md={4} sm={6} xs={6}>
                {dropLabelFirst ? (
                    <DropdownLabel showAstrisk={false}>
                        {dropLabelFirst}
                    </DropdownLabel>
                ) : null}

                <Select
                    id="uiv-select"
                    placeholder={uiv ? uiv : t('reportUsage.procedure.unidSurgery.questionDropDown.uiv')}
                    options={options.filter((x) => x !== uiv)}
                    borderRadius="6px"
                    labelColor={'#495057'}
                    height="40px"
                    width={isMobileView() ? 'unset' : '82px'}
                    onChange={(value) =>
                        onChange({
                            id: 'uiv-select',
                            field: t('reportUsage.procedure.unidSurgery.questionDropDown.uiv'),
                            value: value,
                        })
                    }
                    value={uiv}
                    optionLabel={optionLabel}
                />
            </Grid>
            <Grid lg={10} md={8} sm={8} xs={6}>
                {dropLabelSecond ? (
                    <DropdownLabel showAstrisk={false}>
                        {dropLabelSecond}
                    </DropdownLabel>
                ) : null}
                <Select
                    id="liv-select"
                    placeholder={liv ? liv : t('reportUsage.procedure.unidSurgery.questionDropDown.LIV')}
                    options={options.filter((x) => x !== liv)}
                    height="40px"
                    width={isMobileView() ? 'unset' : '82px'}
                    borderRadius="6px"
                    labelColor={'#495057'}
                    onChange={(value) =>
                        onChange({
                            id: 'liv-select',
                            field: t('reportUsage.procedure.unidSurgery.questionDropDown.LIV'),
                            value: value,
                        })
                    }
                    value={liv}
                    optionLabel={optionLabel}
                />
            </Grid>
        </div>
    );
};

export default QuestionDropDown;
